module.exports = __webpack_public_path__ + "img/thumbnail_Bonobo_f_albino.32cd3c8c.png";